import React, {Component} from 'react';
import ReactModal from 'react-modal';
import Loader from 'react-loader-spinner';
import {injectStripe, CardElement} from 'react-stripe-elements';
import {inject} from 'mobx-react';
import {withRouter} from 'react-router-dom';
import logo from '../../../images/PartLogo.png';
import './cardForm.css';

@withRouter
@inject('alertStore')
@inject('userStore')
class CheckoutForm extends Component {
  constructor() {
    super();
    this.state = {
      isValidCardInfo: false,
      isLoading: false
    };
    // this.httpClient = new HttpClient;
  }

  completeOrder = (clientSecret) => {
    const {stripe} = this.props;

    stripe.retrievePaymentIntent(clientSecret)
    .then(() => {
      // const paymentIntent = result.paymentIntent;
      this.setState({isLoading: false});
      this.props.hideStripeModal();
      this.props.alertStore.success('Transaction Pending - please refresh the page');
      this.props.history.push('/settings/payments');
    });
  }

  handleSubmit = async (ev) => {
    ev.preventDefault();
    const {stripe, elements, onToken} = this.props;
    this.setState({isLoading: true});
    try {
      if (!stripe || !elements) {
        return;
      }
      const payload = await stripe.createPaymentMethod({
        type: 'card',
        card: elements.getElement('card')
      });
      const payment_method = payload.paymentMethod.id;
      const data = await onToken(payment_method)

      if(data.body && data.body.payment_intent_client_secret) {
        stripe.confirmCardPayment(data.body.payment_intent_client_secret, {
          payment_method: {
            card: elements.getElement('card')
          }
        })
        .then(result => {
          if(result.error) {
            this.setState({isLoading: false});
            // console.log(result.error)
            this.props.hideStripeModal();
            this.props.alertStore.success('Something went wrong');
          } else {
            this.completeOrder(
              data.body.payment_intent_client_secret,
            );
          }
        });
      }
    } catch (e) {
      // console.log(e);
      if(e.response) {
        if(e.response.status === 409) {
          const client_secret = e.response.data.payment.client_secret;
          stripe.confirmCardPayment(client_secret, {
            payment_method: {
              card: elements.getElement('card')
            }
          })
          .then(result => {
            if(result.error) {
              this.setState({isLoading: false});
              this.props.alertStore.success('Something went wrong');
              this.props.hideStripeModal();
              // console.log(result.error)
            } else this.completeOrder(client_secret);
          });
        } else {
          this.setState({isLoading: false});
          this.props.alertStore.success('Something went wrong');
          this.props.hideStripeModal();
        }
      } else {
        this.setState({isLoading: false});
        this.props.alertStore.success('Something went wrong');
        this.props.hideStripeModal();
      }
    }
  };

  decline = () => {
    this.props.hideStripeModal();
  };

  onChange = event => {
    const {isValidCardInfo} = this.state;
    if(event.complete) {
      this.setState({isValidCardInfo: true});
    } else if(isValidCardInfo && !event.complete) {
      this.setState({isValidCardInfo: false});
    }
  }

  render() {
    const {isValidCardInfo, isLoading} = this.state;
    // const {title} = this.props;

    return (
      <ReactModal
        isOpen={this.props.showStripeModal}
        shouldCloseOnOverlayClick={true}
        role="dialog"
        contentLabel="Modal"
        className="modal"
        overlayClassName="modal-overlay"
        portalClassName="modal-portal"
      >
        <div className="modal-content" style={{position: 'relative'}}>
          <div
            style={{
              position: 'absolute',
              width: '64px',
              height: '64px',
              borderRadius: '100%',
              backgroundColor: 'white',
              position: 'absolute',
              top: '-80px',
              right: '0',
              left: '0',
              margin: '0 auto',
              border: '5px solid white'
            }}
          >
            <img src={logo} width='90%' height='100%' />
          </div>
          <h1
            style={{
              fontSize: '17px',
              fontWeight: '700',
              color: '#000',
              textAlign: 'center',
              marginTop: '50px'
            }}
          >Final Med Exam Prep</h1>
          <h2
            style={{
              fontSize: '13px',
              fontWeight: '500',
              color: '#5b5b65',
              textShadow: '0 1px 0 #fff',
              paddingBottom: '6px',
              textAlign: 'center'
            }}
          >
            {'annual subscription'}
          </h2>
          <div
            style={{
              padding: '12px 36px',
              textAlign: 'center'
            }}
          >
            <div
              style={{
                height: '1px',
                backgroundImage: 'radial-gradient(circle,hsla(0,0%,100%,.31),hsla(0,0%,100%,0))',
                marginBottom: '6px'
              }}
            />
            <span
              style={{
                maxWidth: '100%',
                overflowX: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                display: 'inline-block',
                color: '#919199',
                textShadow: '0 1px 0 hsl(0deg 0% 100% / 40%)',
                verticalAlign: 'top',
                textAlign: 'center'
              }}
            >
              {this.props.email}
            </span>
          </div>
          <form onSubmit={this.handleSubmit}>
            <div
              style={{
                borderRadius: '4px',
                padding: '9px',
                height: '37px',
                borderColor: 'hsla(240,1%,49%,.25)',
                border: '1px solid hsla(240,1%,49%,.25)'
              }}
            >
              <CardElement
                hidePostalCode
                onChange={this.onChange}
                style={{
                  base: {
                    color: '#32325D',
                    fontWeight: '500',
                    fontFamily: 'Inter UI, Open Sans, Segoe UI, sans-serif',
                    fontSize: '16px',
                    fontSmoothing: 'antialiased',
            
                    '::placeholder': {
                      color: '#919199'
                    }
                  },
                  invalid: {
                    color: '#E25958'
                  }
                }}
              />
            </div>
          </form>
        </div>
        <div className="modal-btns">
          <button className="btn" onClick={this.decline}>
            Cancel
          </button>
          <button className="btn main-btn" onClick={this.handleSubmit} disabled={!isValidCardInfo || isLoading} style={isValidCardInfo ? {whiteSpace: 'initial'} : {opacity: .5, whiteSpace: 'initial'}}>
            {isLoading ? (
              <Loader
                type="TailSpin"
                color="#000"
                height={25}
                width={25}
                timeout={3000} //3 secs
              />
            ) : this.props.cost}
          </button>
        </div>
      </ReactModal>
    );
  }
}

export default injectStripe(CheckoutForm);


// WEBPACK FOOTER //
// ./src/modules/profile/components/CardForm.js